import { listRefs, type GameMap } from '../api/game-refs';

// ============================================================
// Авторы карт для автоподстановки (модалка карты + админка).
// Источник — справочник карт; кэш 30с, чтобы не дёргать API на каждую карточку.
// ============================================================

let authors: string[] = [];
let fetchedAt = 0;
let pending: Promise<void> | null = null;

/** Уникальные непустые авторы по алфавиту. */
function normalizeAuthors(list: Array<string | null | undefined>): string[] {
    return [...new Set(
        list.filter((a): a is string => typeof a === 'string' && !!a.trim())
    )].sort((a, b) => a.localeCompare(b));
}

/** Задать авторов из уже загруженного списка карт (без запроса). */
export function setMapAuthors(list: Array<string | null | undefined>): void {
    authors = normalizeAuthors(list);
    fetchedAt = Date.now();
}

/** Текущий список авторов (для выпадашки автокомплита). */
export function getMapAuthors(): string[] {
    return authors;
}

/** Подгружает авторов из справочника карт, если кэш устарел. */
export function loadMapAuthors(maxAgeMs = 30_000): Promise<void> {
    if (Date.now() - fetchedAt < maxAgeMs) return Promise.resolve();
    if (pending) return pending;
    pending = (async () => {
        try {
            const maps = await listRefs<GameMap>('maps');
            setMapAuthors(maps.map((m) => m.author));
        } catch {
            /* подсказки не критичны */
        } finally {
            pending = null;
        }
    })();
    return pending;
}
